import { useGetEmployeeNotes } from '@/api/performance-profile';

/**
 * Every note of one assessment is read in a single page, the largest the server serves. Past that
 * many noted questions a note box would open empty on an existing note; the server still keeps one
 * note per question, so saving there is refused instead of writing a second one.
 */
const ASSESSMENT_NOTES_PAGE = 1;
const ASSESSMENT_NOTES_PAGE_SIZE = 50;

/**
 * The employee notes written under the questions of one manager assessment. The survey's question
 * notes and the results' notes tab read them through this one query key, so the assessment is
 * fetched once however many questions ask for their note.
 */
export const useAssessmentNotes = (
    employeeId: string | undefined,
    cycleInstanceId: string | undefined,
) =>
    useGetEmployeeNotes({
        // Without the assessment the read would not be narrowed to it: it waits instead.
        employeeId: cycleInstanceId ? employeeId : undefined,
        category: null,
        pageNumber: ASSESSMENT_NOTES_PAGE,
        pageSize: ASSESSMENT_NOTES_PAGE_SIZE,
        origin: { cycleInstanceId },
    });
